const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostTolet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.34,427.12c33.51-52.56,42.11-118.88,32.53-179.7a236.74,236.74,0,0,0-8-34.21C662.33,138.69,601.94,79,530.47,47.59c-68.19-30-154.39-44.82-219,1.35-42.54,30.4-66.63,79.12-105.58,113.22-19.36,17-40.55,22.45-63.59,32.59C86.17,219.46,39.18,267.11,35.32,330a167.49,167.49,0,0,0,23.26,97.15Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.34,427.12c33.51-52.56,42.11-118.88,32.53-179.7a236.74,236.74,0,0,0-8-34.21C662.33,138.69,601.94,79,530.47,47.59c-68.19-30-154.39-44.82-219,1.35-42.54,30.4-66.63,79.12-105.58,113.22-19.36,17-40.55,22.45-63.59,32.59C86.17,219.46,39.18,267.11,35.32,330a167.49,167.49,0,0,0,23.26,97.15Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.54,82.35c-.22-.71-.46-1.41-.72-2.12-9.41-26.18-53.2-28-53.2,4.19,0,6.19-14.87,0-20.44,8s.62,13-6.82,15.49-8.05-3.72-17.35-3.1-8.05,9.29-11.15,11.77-3.1,1.24-9.91,1.86-8.06,5.58-8.06,5.58h163s6.19-18.59-5-25.4-11.15,2.47-19.83-1.24C393.89,94.36,392.55,88.53,390.54,82.35Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,117.29s3.37-10.43-4.91-18.11-16.88-3.37-19.33,0-2.46,9.82-6.45,10.44-3.06-6.75-11.66-4.91-5.21,10.43-9.2,12.27-4-4.91-9.52-2.76-5.21,6.14-5.21,6.14",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.11,96.44a15.56,15.56,0,0,0-15.72-1.36c-8.88,4.1-4.78,12.64-8.88,14.69s-6.15-.35-11.28,2-4.78,5.8-4.78,5.8",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.06,140.48c-.1-.3-.21-.61-.32-.92-4.09-11.39-23.14-12.17-23.14,1.82,0,2.7-6.47,0-8.9,3.5s.27,5.67-3,6.74-3.51-1.61-7.55-1.34-3.51,4-4.85,5.12-1.35.54-4.32.81-3.5,2.42-3.5,2.42h70.89s2.7-8.08-2.16-11-4.85,1.08-8.62-.54C274.51,145.7,273.93,143.17,273.06,140.48Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.51,155.68a7.9,7.9,0,0,0-2.14-7.87c-3.6-3.34-7.34-1.47-8.41,0s-1.07,4.27-2.8,4.54-1.34-2.94-5.08-2.14-2.27,4.54-4,5.34-1.74-2.14-4.14-1.2-2.27,2.67-2.27,2.67",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.33,146.61a6.74,6.74,0,0,0-6.83-.59c-3.87,1.78-2.09,5.5-3.87,6.39s-2.67-.15-4.9.89-2.08,2.53-2.08,2.53",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.12,140.48c-.1-.3-.2-.61-.31-.92-4.1-11.39-23.15-12.17-23.15,1.82,0,2.7-6.47,0-8.89,3.5s.27,5.67-3,6.74-3.5-1.61-7.54-1.34-3.51,4-4.86,5.12-1.34.54-4.31.81-3.5,2.42-3.5,2.42h70.89s2.69-8.08-2.16-11-4.85,1.08-8.62-.54C649.58,145.7,649,143.17,648.12,140.48Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.57,155.68a7.91,7.91,0,0,0-2.13-7.87c-3.61-3.34-7.34-1.47-8.41,0s-1.07,4.27-2.81,4.54-1.33-2.94-5.07-2.14-2.27,4.54-4,5.34-1.74-2.14-4.14-1.2-2.27,2.67-2.27,2.67",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.4,146.61a6.75,6.75,0,0,0-6.84-.59c-3.86,1.78-2.08,5.5-3.86,6.39s-2.68-.15-4.91.89-2.08,2.53-2.08,2.53",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.18,392.7a15.17,15.17,0,0,0,4.42.49s-.67-2.05-.73-2.17c-.69-1.44-2.86-3.82-4.63-3.58a2.11,2.11,0,0,0-1.7,2.65A4.37,4.37,0,0,0,110.18,392.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,425.9a2.12,2.12,0,0,0-1.17-2.93c-1.69-.56-4.28,1.36-5.22,2.64,0,.06-.36.6-.65,1.1h6.45A2.9,2.9,0,0,0,141,425.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.42,417.57a13.42,13.42,0,0,0,3.77,1.75c-.13.62-.26,1.23-.42,1.83-.11.4-.19.79-.33,1.19s-.25.78-.38,1.17c-.27.74-.54,1.5-.82,2.21-.13.35-.26.67-.39,1h1.05c.08-.21.16-.42.24-.65.27-.74.52-1.48.79-2.28l.36-1.18c.12-.39.21-.82.31-1.24.23-1,.42-1.95.59-3a13.8,13.8,0,0,0,4.14,1,4.44,4.44,0,0,0,3.37-1.58,2.12,2.12,0,0,0-.71-3.07c-1.59-.81-4.44.69-5.57,1.82-.07.07-.79,1-1.17,1.47.09-.6.19-1.21.26-1.82.22-1.77.39-3.57.57-5.36,0-.55.11-1.1.17-1.65a14.6,14.6,0,0,0,4.28,1,4.44,4.44,0,0,0,3.37-1.58,2.12,2.12,0,0,0-.71-3.07c-1.59-.81-4.44.69-5.57,1.82-.08.08-1.12,1.38-1.36,1.72.12-1.21.26-2.41.45-3.59a37.09,37.09,0,0,1,1-4.71,14.78,14.78,0,0,0,4.31,1,4.4,4.4,0,0,0,3.36-1.58,2.1,2.1,0,0,0-.71-3.06c-1.59-.82-4.43.69-5.56,1.82-.09.08-1.2,1.48-1.39,1.74a2.68,2.68,0,0,0,.07-.27,26.89,26.89,0,0,1,1.87-4.46c.41-.8.84-1.54,1.28-2.24a14.4,14.4,0,0,0,4.08,1.43,4.39,4.39,0,0,0,3.52-1.2,2.11,2.11,0,0,0-.37-3.12c-1.49-1-4.48.2-5.73,1.19-.07.06-.7.68-1.15,1.14l.61-.94c.74-1.13,1.5-2.11,2.17-3,.39-.49.75-.92,1.09-1.33a14,14,0,0,0,4.26-.6,4.41,4.41,0,0,0,2.57-2.69,2.11,2.11,0,0,0-1.76-2.6c-1.78-.19-3.89,2.24-4.54,3.7-.06.13-.71,2.2-.67,2.2h0c-.33.38-.69.79-1.07,1.25-.69.85-1.47,1.82-2.24,2.94a37.15,37.15,0,0,0-2.33,3.71,26.17,26.17,0,0,0-2,4.48s0,0,0,.05c0-.52,0-2,0-2.1-.2-1.58-1.53-4.51-3.29-4.84a2.11,2.11,0,0,0-2.43,2,4.42,4.42,0,0,0,1.69,3.31,15.07,15.07,0,0,0,4,1.83,37.33,37.33,0,0,0-1.18,4.85c-.17,1-.31,1.92-.44,2.9,0-.46,0-.86,0-.92-.21-1.58-1.53-4.51-3.29-4.84a2.12,2.12,0,0,0-2.44,2,4.44,4.44,0,0,0,1.7,3.31,14.21,14.21,0,0,0,3.88,1.79c0,.37-.09.74-.14,1.12-.21,1.79-.42,3.58-.67,5.33-.09.62-.2,1.22-.31,1.82,0-.4,0-.74,0-.79-.2-1.58-1.53-4.51-3.28-4.84a2.12,2.12,0,0,0-2.44,2A4.44,4.44,0,0,0,131.42,417.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,401.79a14.68,14.68,0,0,0,4.35-.69,37.87,37.87,0,0,0,1.69,4.7c.39.89.8,1.77,1.23,2.66-.25-.38-.48-.71-.52-.75-1-1.21-3.77-2.93-5.42-2.23a2.12,2.12,0,0,0-.93,3,4.43,4.43,0,0,0,3.24,1.82,14.19,14.19,0,0,0,4.23-.65c.16.34.33.68.5,1,.81,1.61,1.62,3.22,2.37,4.82.27.57.51,1.13.75,1.69-.22-.33-.42-.6-.45-.64-1-1.21-3.77-2.93-5.42-2.23a2.11,2.11,0,0,0-.93,3,4.41,4.41,0,0,0,3.24,1.83,13.61,13.61,0,0,0,4.11-.62c.23.59.47,1.17.66,1.75.13.4.28.77.38,1.18l.33,1.19c.19.76.38,1.55.54,2.29.12.52.22,1,.32,1.52-.26-.56-.79-1.66-.84-1.74-.85-1.35-3.28-3.46-5-3a2.12,2.12,0,0,0-1.39,2.83,4.26,4.26,0,0,0,2.65,2.19h5.67c0-.12-.06-.24-.08-.37a21.79,21.79,0,0,0,2.44-1.15,9.8,9.8,0,0,0,2.1,1.52h1.66c.09-.62.19-1.38.19-1.46a8.12,8.12,0,0,0-1.1-4,1.83,1.83,0,0,0,0-.47,2.11,2.11,0,0,0-2.58-1.8c-1.73.46-2.82,3.49-2.91,5.09,0,.09.06,1.12.11,1.76-.09-.37-.17-.74-.26-1.12-.18-.77-.39-1.52-.6-2.34l-.36-1.18c-.11-.4-.28-.8-.41-1.21-.35-.93-.74-1.86-1.15-2.79a13.81,13.81,0,0,0,4-1.49,4.42,4.42,0,0,0,1.94-3.17,2.13,2.13,0,0,0-2.29-2.17c-1.77.2-3.31,3-3.63,4.59,0,.1-.13,1.24-.18,1.87-.25-.55-.5-1.11-.77-1.66-.8-1.6-1.65-3.19-2.5-4.79l-.76-1.46a14.84,14.84,0,0,0,4.13-1.53,4.45,4.45,0,0,0,1.94-3.17,2.12,2.12,0,0,0-2.29-2.16c-1.77.19-3.31,3-3.64,4.58,0,.12-.17,1.77-.19,2.19-.56-1.08-1.1-2.16-1.6-3.24a36.2,36.2,0,0,1-1.74-4.5,15.27,15.27,0,0,0,4.15-1.53,4.46,4.46,0,0,0,1.94-3.18,2.12,2.12,0,0,0-2.29-2.16c-1.77.19-3.31,3-3.63,4.58,0,.12-.19,1.9-.2,2.22,0-.08-.06-.17-.09-.26A28,28,0,0,1,115,396c-.1-.88-.15-1.74-.17-2.57a14.33,14.33,0,0,0,4.19-1.05,4.44,4.44,0,0,0,2.28-2.94,2.13,2.13,0,0,0-2-2.41c-1.79,0-3.63,2.64-4.12,4.16,0,.08-.21.95-.33,1.59,0-.38,0-.77,0-1.13,0-1.35.09-2.58.17-3.68.06-.62.12-1.18.18-1.71a14.05,14.05,0,0,0,3.22-2.85,4.44,4.44,0,0,0,.66-3.66,2.12,2.12,0,0,0-2.91-1.2c-1.59.82-2,4-1.74,5.59,0,.14.62,2.22.65,2.2l0,0c-.07.51-.14,1.05-.2,1.64-.11,1.1-.22,2.33-.26,3.69a38.78,38.78,0,0,0,.11,4.38,27.53,27.53,0,0,0,.81,4.83l0,.06c-.28-.44-1.11-1.65-1.18-1.74-1-1.2-3.77-2.92-5.42-2.22a2.11,2.11,0,0,0-.93,3A4.42,4.42,0,0,0,111.27,401.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,393.39s.57-2.08.59-2.22c.22-1.58-.29-4.76-1.9-5.54a2.11,2.11,0,0,0-2.87,1.28,4.42,4.42,0,0,0,.76,3.64A15.17,15.17,0,0,0,141.9,393.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,405.8a9.48,9.48,0,0,0,2.72.3s-.41-1.26-.45-1.34c-.42-.88-1.76-2.35-2.85-2.2a1.29,1.29,0,0,0-1,1.63A2.74,2.74,0,0,0,79,405.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.91,426.21a1.3,1.3,0,0,0-.71-1.8c-1-.35-2.64.84-3.22,1.63,0,0-.22.36-.39.67h4A1.49,1.49,0,0,0,97.91,426.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,421.09a8.4,8.4,0,0,0,2.32,1.08c-.08.38-.16.76-.26,1.12s-.12.49-.2.73-.16.49-.23.72c-.17.46-.34.93-.51,1.36l-.24.61h.65l.15-.4c.16-.45.31-.91.48-1.4.07-.24.14-.48.22-.73s.13-.5.19-.76c.15-.59.26-1.2.36-1.82a8.48,8.48,0,0,0,2.55.59,2.71,2.71,0,0,0,2.07-1,1.3,1.3,0,0,0-.44-1.89c-1-.5-2.72.43-3.42,1.12l-.72.9c.06-.37.12-.74.16-1.11.14-1.09.24-2.2.35-3.3,0-.34.07-.68.1-1a9.16,9.16,0,0,0,2.64.61,2.71,2.71,0,0,0,2.07-1,1.29,1.29,0,0,0-.44-1.88c-1-.5-2.72.42-3.42,1.12,0,.05-.69.84-.84,1.05.08-.74.16-1.48.28-2.2a21.89,21.89,0,0,1,.63-2.9,9.4,9.4,0,0,0,2.65.62,2.71,2.71,0,0,0,2.07-1,1.29,1.29,0,0,0-.44-1.88c-1-.51-2.72.42-3.42,1.11-.05.06-.74.91-.85,1.08a1.36,1.36,0,0,0,0-.17,17.59,17.59,0,0,1,1.15-2.75c.25-.48.52-.94.79-1.37a8.83,8.83,0,0,0,2.51.88,2.71,2.71,0,0,0,2.16-.74,1.3,1.3,0,0,0-.23-1.92c-.91-.61-2.75.12-3.52.74,0,0-.43.41-.7.7.12-.2.24-.4.37-.58.46-.7.92-1.3,1.33-1.83l.67-.82a8.73,8.73,0,0,0,2.62-.37,2.73,2.73,0,0,0,1.59-1.65,1.3,1.3,0,0,0-1.09-1.6c-1.09-.12-2.39,1.37-2.79,2.27,0,.08-.44,1.35-.41,1.35h0c-.21.23-.43.49-.66.77-.43.53-.91,1.12-1.38,1.81a21.86,21.86,0,0,0-1.43,2.28,16.84,16.84,0,0,0-1.23,2.75s0,0,0,0c0-.32,0-1.22,0-1.29-.12-1-.94-2.78-2-3a1.31,1.31,0,0,0-1.5,1.22,2.73,2.73,0,0,0,1,2,8.81,8.81,0,0,0,2.46,1.12,23.72,23.72,0,0,0-.72,3c-.11.58-.19,1.18-.27,1.78,0-.28,0-.53,0-.56-.13-1-.94-2.78-2-3a1.29,1.29,0,0,0-1.5,1.22,2.73,2.73,0,0,0,1,2,8.89,8.89,0,0,0,2.39,1.11c0,.23-.06.46-.08.69-.14,1.1-.26,2.2-.42,3.27-.06.38-.12.75-.19,1.13,0-.25,0-.46,0-.49-.13-1-.95-2.78-2-3a1.31,1.31,0,0,0-1.5,1.22A2.73,2.73,0,0,0,92,421.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62,411.38a9,9,0,0,0,2.67-.42,21.85,21.85,0,0,0,1,2.89c.23.55.49,1.09.75,1.64l-.32-.46c-.64-.75-2.32-1.8-3.33-1.37a1.3,1.3,0,0,0-.58,1.84,2.71,2.71,0,0,0,2,1.12,8.58,8.58,0,0,0,2.6-.39l.3.62c.5,1,1,2,1.47,3,.16.35.31.7.46,1l-.28-.4c-.64-.74-2.32-1.79-3.33-1.36a1.3,1.3,0,0,0-.58,1.84,2.71,2.71,0,0,0,2,1.12,8,8,0,0,0,2.53-.38c.15.36.29.72.41,1.08s.17.47.23.72l.21.74c.11.46.23,1,.33,1.41s.13.62.19.93c-.15-.34-.48-1-.51-1.07-.52-.83-2-2.13-3.09-1.86a1.3,1.3,0,0,0-.84,1.74,2.56,2.56,0,0,0,1.62,1.35h3.49a1.74,1.74,0,0,1,0-.22c.13-.06.85-.35,1.5-.71a5.79,5.79,0,0,0,1.29.93h1c.06-.38.12-.85.12-.9a5,5,0,0,0-.68-2.45,1.38,1.38,0,0,0,0-.29,1.3,1.3,0,0,0-1.59-1.1c-1.07.28-1.74,2.14-1.79,3.12,0,.06,0,.69.07,1.09-.06-.23-.11-.46-.16-.7l-.37-1.43c-.08-.24-.15-.48-.22-.73s-.17-.49-.26-.74c-.21-.57-.45-1.15-.71-1.72a8.08,8.08,0,0,0,2.45-.91,2.76,2.76,0,0,0,1.2-1.95,1.3,1.3,0,0,0-1.41-1.33c-1.09.11-2,1.85-2.24,2.81,0,.06-.07.77-.1,1.16-.16-.34-.31-.69-.48-1-.49-1-1-2-1.53-2.94-.16-.3-.32-.6-.47-.9a9.14,9.14,0,0,0,2.54-.94,2.71,2.71,0,0,0,1.19-1.95A1.3,1.3,0,0,0,87,411.55c-1.09.12-2,1.86-2.23,2.82,0,.07-.11,1.09-.12,1.34-.35-.66-.68-1.32-1-2A23.56,23.56,0,0,1,82.55,411,8.76,8.76,0,0,0,85.1,410a2.69,2.69,0,0,0,1.2-1.95,1.3,1.3,0,0,0-1.41-1.33c-1.09.12-2,1.86-2.24,2.82,0,.07-.11,1.17-.11,1.37l-.06-.17a17.63,17.63,0,0,1-.56-2.92c-.06-.55-.08-1.07-.1-1.58a9.23,9.23,0,0,0,2.58-.65,2.72,2.72,0,0,0,1.4-1.81,1.3,1.3,0,0,0-1.25-1.48c-1.1,0-2.23,1.62-2.54,2.56l-.2,1c0-.23,0-.47,0-.69,0-.83.06-1.59.11-2.26,0-.38.07-.73.11-1.05a9.17,9.17,0,0,0,2-1.76,2.7,2.7,0,0,0,.4-2.25,1.29,1.29,0,0,0-1.79-.73c-1,.5-1.23,2.47-1.07,3.43,0,.09.39,1.37.4,1.36l0,0c0,.31-.08.65-.12,1-.07.67-.14,1.44-.16,2.27a22.58,22.58,0,0,0,.07,2.69,16.27,16.27,0,0,0,.5,3,0,0,0,0,0,0,0l-.73-1.07c-.64-.74-2.32-1.79-3.33-1.37a1.31,1.31,0,0,0-.58,1.85A2.71,2.71,0,0,0,79.62,411.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,406.22s.35-1.28.37-1.36c.13-1-.18-2.93-1.17-3.41a1.31,1.31,0,0,0-1.77.78,2.73,2.73,0,0,0,.47,2.24A9.43,9.43,0,0,0,98.45,406.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.88,405.8a9.45,9.45,0,0,0,2.72.3s-.42-1.26-.45-1.34c-.43-.88-1.77-2.35-2.85-2.2a1.31,1.31,0,0,0-1,1.63A2.76,2.76,0,0,0,601.88,405.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.84,426.21a1.31,1.31,0,0,0-.72-1.8c-1-.35-2.63.84-3.21,1.63,0,0-.22.36-.4.67h4A1.64,1.64,0,0,0,620.84,426.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.94,421.09a8.27,8.27,0,0,0,2.32,1.08c-.09.38-.16.76-.26,1.12s-.12.49-.2.73-.16.49-.24.72c-.16.46-.33.93-.5,1.36l-.24.61h.64l.15-.4c.17-.45.32-.91.49-1.4.07-.24.14-.48.22-.73s.12-.5.19-.76c.14-.59.26-1.2.36-1.82a8.41,8.41,0,0,0,2.55.59,2.72,2.72,0,0,0,2.07-1,1.31,1.31,0,0,0-.44-1.89c-1-.5-2.73.43-3.42,1.12,0,0-.49.6-.72.9.05-.37.11-.74.16-1.11.14-1.09.24-2.2.35-3.3,0-.34.07-.68.1-1a9.08,9.08,0,0,0,2.64.61,2.72,2.72,0,0,0,2.07-1,1.3,1.3,0,0,0-.44-1.88c-1-.5-2.73.42-3.42,1.12,0,.05-.69.84-.84,1.05.08-.74.16-1.48.27-2.2a23.6,23.6,0,0,1,.64-2.9,9.22,9.22,0,0,0,2.65.62,2.72,2.72,0,0,0,2.07-1,1.3,1.3,0,0,0-.44-1.88c-1-.51-2.73.42-3.42,1.11-.06.06-.74.91-.85,1.08a.85.85,0,0,1,0-.17,16.68,16.68,0,0,1,1.15-2.75c.25-.48.52-.94.79-1.37a8.86,8.86,0,0,0,2.5.88,2.71,2.71,0,0,0,2.17-.74,1.3,1.3,0,0,0-.23-1.92c-.91-.61-2.75.12-3.52.74,0,0-.43.41-.71.7l.37-.58c.46-.7.93-1.3,1.34-1.83l.67-.82a8.73,8.73,0,0,0,2.62-.37,2.74,2.74,0,0,0,1.58-1.65,1.29,1.29,0,0,0-1.08-1.6c-1.1-.12-2.39,1.37-2.79,2.27,0,.08-.44,1.35-.42,1.35h0c-.21.23-.43.49-.66.77-.43.53-.91,1.12-1.39,1.81a25.81,25.81,0,0,0-1.43,2.28,17.72,17.72,0,0,0-1.22,2.75s0,0,0,0c0-.32,0-1.22,0-1.29-.12-1-.94-2.78-2-3a1.3,1.3,0,0,0-1.5,1.22,2.75,2.75,0,0,0,1,2,9,9,0,0,0,2.47,1.12,23.73,23.73,0,0,0-.73,3c-.1.58-.19,1.18-.27,1.78,0-.28,0-.53,0-.56-.13-1-.94-2.78-2-3a1.29,1.29,0,0,0-1.5,1.22,2.66,2.66,0,0,0,1,2,8.62,8.62,0,0,0,2.39,1.11l-.09.69c-.13,1.1-.26,2.2-.41,3.27-.06.38-.13.75-.19,1.13,0-.25,0-.46,0-.49-.12-1-.94-2.78-2-3a1.3,1.3,0,0,0-1.5,1.22A2.73,2.73,0,0,0,614.94,421.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.54,411.38a9.07,9.07,0,0,0,2.68-.42,23.3,23.3,0,0,0,1,2.89c.24.55.49,1.09.76,1.64l-.32-.46c-.65-.75-2.32-1.8-3.33-1.37a1.3,1.3,0,0,0-.58,1.84,2.69,2.69,0,0,0,2,1.12,8.53,8.53,0,0,0,2.6-.39c.11.2.21.41.31.62.5,1,1,2,1.46,3,.17.35.31.7.46,1l-.28-.4c-.64-.74-2.31-1.79-3.33-1.36a1.3,1.3,0,0,0-.57,1.84,2.69,2.69,0,0,0,2,1.12,8,8,0,0,0,2.53-.38c.14.36.29.72.41,1.08s.17.47.23.72l.21.74c.11.46.23,1,.33,1.41s.13.62.19.93c-.16-.34-.48-1-.52-1.07-.52-.83-2-2.13-3.08-1.86a1.3,1.3,0,0,0-.85,1.74,2.6,2.6,0,0,0,1.63,1.35H612a1.74,1.74,0,0,0-.05-.22c.13-.06.86-.35,1.51-.71a5.79,5.79,0,0,0,1.29.93h1c0-.38.12-.85.12-.9a5.09,5.09,0,0,0-.68-2.45,1.37,1.37,0,0,0,0-.29,1.29,1.29,0,0,0-1.59-1.1c-1.06.28-1.73,2.14-1.78,3.12,0,.06,0,.69.06,1.09-.05-.23-.1-.46-.16-.7-.11-.46-.23-.93-.37-1.43-.07-.24-.14-.48-.22-.73s-.17-.49-.25-.74c-.21-.57-.45-1.15-.71-1.72a8.18,8.18,0,0,0,2.45-.91,2.72,2.72,0,0,0,1.19-1.95,1.29,1.29,0,0,0-1.4-1.33c-1.09.11-2,1.85-2.24,2.81,0,.06-.08.77-.1,1.16-.16-.34-.31-.69-.48-1-.49-1-1-2-1.54-2.94-.15-.3-.31-.6-.47-.9a8.92,8.92,0,0,0,2.54-.94,2.68,2.68,0,0,0,1.19-1.95,1.29,1.29,0,0,0-1.4-1.33c-1.09.12-2,1.86-2.24,2.82,0,.07-.1,1.09-.11,1.34-.35-.66-.69-1.32-1-2a21.93,21.93,0,0,1-1.07-2.77A8.76,8.76,0,0,0,608,410a2.68,2.68,0,0,0,1.19-1.95,1.29,1.29,0,0,0-1.4-1.33c-1.09.12-2,1.86-2.24,2.82,0,.07-.11,1.17-.12,1.37,0-.06,0-.11-.05-.17a16.66,16.66,0,0,1-.56-2.92c-.06-.55-.09-1.07-.1-1.58a9.31,9.31,0,0,0,2.58-.65,2.75,2.75,0,0,0,1.4-1.81,1.31,1.31,0,0,0-1.25-1.48c-1.1,0-2.24,1.62-2.54,2.56l-.2,1c0-.23,0-.47,0-.69,0-.83,0-1.59.11-2.26,0-.38.07-.73.1-1.05a8.72,8.72,0,0,0,2-1.76,2.7,2.7,0,0,0,.41-2.25,1.3,1.3,0,0,0-1.79-.73c-1,.5-1.23,2.47-1.07,3.43,0,.09.38,1.37.4,1.36l0,0c0,.31-.09.65-.13,1-.06.67-.13,1.44-.15,2.27a24.79,24.79,0,0,0,.06,2.69,18.18,18.18,0,0,0,.5,3v0c-.17-.27-.68-1-.72-1.07-.65-.74-2.32-1.79-3.33-1.37a1.31,1.31,0,0,0-.58,1.85A2.69,2.69,0,0,0,602.54,411.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.38,406.22s.35-1.28.36-1.36c.14-1-.17-2.93-1.16-3.41a1.31,1.31,0,0,0-1.77.78,2.73,2.73,0,0,0,.47,2.24A9.43,9.43,0,0,0,621.38,406.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.38,161.26s44.73,4.42,67.39,32.15c0,0,23.95-32.12,67-31.46a86.94,86.94,0,1,0-134.37-.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,161.26s44.73,4.42,67.39,32.15c0,0,23.95-32.12,67-31.46a86.94,86.94,0,1,0-134.37-.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,111s-26.74,6.34-41.5,27.84l-.84-31.27.06.41s15.1-27.17,42.28-35.48c0,0-28,6.64-42.49,29.36l-2.06-42.1-.63,60.34c-14.22-21.61-40.13-28-40.13-28,22.89,7.25,36.89,28.87,40.09,34.25l-.21,31.1c-14.27-21.31-39.88-27.6-39.88-27.6,22.34,7.07,36.22,27.84,39.84,33.83l-.59,263.54h7.55L139.5,181.83c4.87-7.37,18.81-25.78,40.34-32.36,0,0-25.57,6.07-40.5,26.44l-.83-31C142.18,139,156.58,118.08,179.84,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,111s-26.74,6.34-41.5,27.84l-.84-31.27.06.41s15.1-27.17,42.28-35.48c0,0-28,6.64-42.49,29.36l-2.06-42.1-.63,60.34c-14.22-21.61-40.13-28-40.13-28,22.89,7.25,36.89,28.87,40.09,34.25l-.21,31.1c-14.27-21.31-39.88-27.6-39.88-27.6,22.34,7.07,36.22,27.84,39.84,33.83l-.59,263.54h7.55L139.5,181.83c4.87-7.37,18.81-25.78,40.34-32.36,0,0-25.57,6.07-40.5,26.44l-.83-31C142.18,139,156.58,118.08,179.84,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.13,304.65s36.46,3.61,55,26.22c0,0,19.53-26.19,54.6-25.65a70.88,70.88,0,1,0-109.57-.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.13,304.65s36.46,3.61,55,26.22c0,0,19.53-26.19,54.6-25.65a70.88,70.88,0,1,0-109.57-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.63,279c18.22,5.77,29.53,22.7,32.48,27.59l-.26,120.49h5.24L92.3,321.43c4-6,15.34-21,32.89-26.38,0,0-20.85,4.94-33,21.55l-.68-25.3c3-4.81,14.74-21.85,33.7-27.65,0,0-21.8,5.17-33.83,22.7l-.69-25.5,0,.34S103,239,125.19,232.26c0,0-22.82,5.42-34.65,23.94l-1.67-34.32-.52,49.19c-11.59-17.62-32.72-22.81-32.72-22.81,18.66,5.91,30.08,23.54,32.69,27.93l-.17,25.36C76.51,284.18,55.63,279,55.63,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.63,279c18.22,5.77,29.53,22.7,32.48,27.59l-.26,120.49h5.24L92.3,321.43c4-6,15.34-21,32.89-26.38,0,0-20.85,4.94-33,21.55l-.68-25.3c3-4.81,14.74-21.85,33.7-27.65,0,0-21.8,5.17-33.83,22.7l-.69-25.5,0,.34S103,239,125.19,232.26c0,0-22.82,5.42-34.65,23.94l-1.67-34.32-.52,49.19c-11.59-17.62-32.72-22.81-32.72-22.81,18.66,5.91,30.08,23.54,32.69,27.93l-.17,25.36C76.51,284.18,55.63,279,55.63,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.36,304.65s36.47,3.61,54.95,26.22c0,0,19.53-26.19,54.6-25.65a70.89,70.89,0,1,0-109.56-.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.36,304.65s36.47,3.61,54.95,26.22c0,0,19.53-26.19,54.6-25.65a70.89,70.89,0,1,0-109.56-.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.87,279c18.21,5.77,29.53,22.7,32.48,27.59l-.27,120.49h5.24l-.78-105.69c4-6,15.33-21,32.88-26.38,0,0-20.84,4.94-33,21.55l-.69-25.3c3-4.81,14.74-21.85,33.7-27.65,0,0-21.8,5.17-33.83,22.7l-.69-25.5.05.34s12.31-22.16,34.47-28.93c0,0-22.81,5.42-34.64,23.94l-1.67-34.32-.52,49.19c-11.6-17.62-32.72-22.81-32.72-22.81,18.66,5.91,30.08,23.54,32.68,27.93l-.17,25.36C601.75,284.18,580.87,279,580.87,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.87,279c18.21,5.77,29.53,22.7,32.48,27.59l-.27,120.49h5.24l-.78-105.69c4-6,15.33-21,32.88-26.38,0,0-20.84,4.94-33,21.55l-.69-25.3c3-4.81,14.74-21.85,33.7-27.65,0,0-21.8,5.17-33.83,22.7l-.69-25.5.05.34s12.31-22.16,34.47-28.93c0,0-22.81,5.42-34.64,23.94l-1.67-34.32-.52,49.19c-11.6-17.62-32.72-22.81-32.72-22.81,18.66,5.91,30.08,23.54,32.68,27.93l-.17,25.36C601.75,284.18,580.87,279,580.87,279Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-39"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 506.74,
    y1: 143.23,
    x2: 470.7,
    y2: 179.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.71 184.26 469.87 174.35 471.08 178.89 475.62 180.1 465.71 184.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.62,
    y1: 150.4,
    x2: 508.33,
    y2: 180.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "504.78 186.21 506.27 175.57 508.6 179.66 513.3 179.66 504.78 186.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.55,
    y1: 110.02,
    x2: 402.67,
    y2: 179.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.68 183.61 402.97 174.89 403.12 179.59 407.27 181.79 396.68 183.61",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-39"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 554.28,
    cy: 91.79,
    r: 32.56,
    transform: "translate(-7.08 114.76) rotate(-11.75)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.28,
    y1: 35.13,
    x2: 554.28,
    y2: 50.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.28,
    y1: 132.81,
    x2: 554.28,
    y2: 148.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 610.93,
    y1: 91.79,
    x2: 595.3,
    y2: 91.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.25,
    y1: 91.79,
    x2: 497.62,
    y2: 91.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 594.34,
    y1: 51.72,
    x2: 583.29,
    y2: 62.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.27,
    y1: 120.8,
    x2: 514.21,
    y2: 131.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 514.21,
    y1: 51.72,
    x2: 525.27,
    y2: 62.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 583.29,
    y1: 120.8,
    x2: 594.34,
    y2: 131.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.74,
    y: 319.61,
    width: 416.16,
    height: 107.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.74,
    y: 319.61,
    width: 416.16,
    height: 19.06,
    style: {
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.74,
    y: 319.61,
    width: 416.16,
    height: 107.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.48,
    y: 319.61,
    width: 424.69,
    height: 4.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.29 319.69 151.93 319.69 187.79 196.73 546.42 196.73 582.29 319.69",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.39 300.26 173.68 300.26 198.31 208.91 255.1 209.15 238.39 300.26",
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.29,
    y1: 209.09,
    x2: 189.69,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.97,
    y1: 209.15,
    x2: 206.41,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.63,
    y1: 209.21,
    x2: 223.1,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.99,
    y1: 221.58,
    x2: 253.21,
    y2: 221.79,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.08,
    y1: 236.09,
    x2: 250.56,
    y2: 236.26,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.99,
    y1: 251.24,
    x2: 247.8,
    y2: 251.37,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.73,
    y1: 267.07,
    x2: 244.92,
    y2: 267.17,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.26,
    y1: 283.64,
    x2: 241.9,
    y2: 283.69,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.98 300.26 249.72 300.26 265.05 209.19 321.49 209.42 313.98 300.26",
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.96,
    y1: 209.37,
    x2: 265.6,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.55,
    y1: 209.43,
    x2: 282.21,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.12,
    y1: 209.49,
    x2: 298.79,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.01,
    y1: 221.82,
    x2: 320.88,
    y2: 222.03,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.58,
    y1: 236.29,
    x2: 319.69,
    y2: 236.46,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.04,
    y1: 251.4,
    x2: 318.45,
    y2: 251.53,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.39,
    y1: 267.18,
    x2: 317.16,
    y2: 267.28,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.61,
    y1: 283.7,
    x2: 315.81,
    y2: 283.75,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "494.77 300.26 559.47 300.26 534.84 208.91 478.06 209.15 494.77 300.26",
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.86,
    y1: 209.09,
    x2: 543.46,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.18,
    y1: 209.15,
    x2: 526.74,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.53,
    y1: 209.21,
    x2: 510.05,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 538.17,
    y1: 221.58,
    x2: 479.94,
    y2: 221.79,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 542.08,
    y1: 236.09,
    x2: 482.59,
    y2: 236.26,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 546.16,
    y1: 251.24,
    x2: 485.35,
    y2: 251.37,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550.43,
    y1: 267.07,
    x2: 488.24,
    y2: 267.17,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.89,
    y1: 283.64,
    x2: 491.26,
    y2: 283.69,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.17 300.26 483.43 300.26 468.1 209.19 411.66 209.42 419.17 300.26",
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.2,
    y1: 209.37,
    x2: 467.55,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 439.61,
    y1: 209.43,
    x2: 450.95,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.04,
    y1: 209.49,
    x2: 434.37,
    y2: 300.1,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.14,
    y1: 221.82,
    x2: 412.28,
    y2: 222.03,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.57,
    y1: 236.29,
    x2: 413.46,
    y2: 236.46,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.11,
    y1: 251.4,
    x2: 414.7,
    y2: 251.53,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.77,
    y1: 267.18,
    x2: 415.99,
    y2: 267.28,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 480.54,
    y1: 283.7,
    x2: 417.34,
    y2: 283.75,
    style: {
      fill: "#92E3A9",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.77,
    y: 338.66,
    width: 8.04,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.77,
    y: 355.52,
    width: 8.04,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.77,
    y: 370.91,
    width: 8.04,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.77,
    y: 386.31,
    width: 8.04,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.03,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.03,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.03,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.03,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.54,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.54,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.54,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.54,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.8,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.8,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.8,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.8,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.61,
    y: 337.98,
    width: 41.75,
    height: 79.98,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.67,
    y: 342.7,
    width: 30.3,
    height: 39.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.67,
    y: 396.57,
    width: 30.3,
    height: 16.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.67,
    y: 386.47,
    width: 30.3,
    height: 6.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.67,
    y: 376.93,
    width: 3.79,
    height: 12.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.16,
    cy: 325.84,
    r: 7.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.9 338.67 366.4 338.67 365.33 331.89 372.97 331.89 371.9 338.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.36 326.51 366.94 326.51 364.63 331.88 373.66 331.88 371.36 326.51",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.05,
    y: 323.84,
    width: 2.2,
    height: 2.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93,327.81l10.75-3.39a85.76,85.76,0,0,1,49.87-.47l13.11,3.86h21.39V302l-59.5-70.45L308.17,302v25.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.17,
    y: 417.26,
    width: 117.88,
    height: 9.43,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.05,
    y1: 418.22,
    x2: 332.05,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.15,
    y1: 418.22,
    x2: 338.15,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.24,
    y1: 418.22,
    x2: 344.24,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.34,
    y1: 418.22,
    x2: 350.34,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.44,
    y1: 418.22,
    x2: 356.44,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.54,
    y1: 418.22,
    x2: 362.54,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.63,
    y1: 418.22,
    x2: 368.63,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.73,
    y1: 418.22,
    x2: 374.73,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.83,
    y1: 418.22,
    x2: 380.83,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.93,
    y1: 418.22,
    x2: 386.93,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.03,
    y1: 418.22,
    x2: 393.03,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.12,
    y1: 418.22,
    x2: 399.12,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.22,
    y1: 418.22,
    x2: 405.22,
    y2: 425.6,
    style: {
      fill: "none",
      stroke: "#b0b0b0",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.11 222.5 295.05 314.21 329.81 314.21 329.81 305.21 312.17 305.21 367.11 237.46 422.05 305.21 404.51 305.21 404.51 314.21 439.17 314.21 367.11 222.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.05,
    y: 314.21,
    width: 34.71,
    height: 8.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.78,
    y: 336.05,
    width: 10.31,
    height: 84.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 332.96,
    width: 11.49,
    height: 3.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 322.61,
    width: 13.07,
    height: 10.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.19,
    y: 413.07,
    width: 11.49,
    height: 3.2,
    transform: "translate(611.87 829.34) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 416.09,
    width: 13.07,
    height: 10.53,
    transform: "translate(611.87 842.71) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.14,
    y: 336.05,
    width: 10.31,
    height: 84.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.56,
    y: 332.96,
    width: 11.49,
    height: 3.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.77,
    y: 322.61,
    width: 13.07,
    height: 10.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.56,
    y: 413.07,
    width: 11.49,
    height: 3.2,
    transform: "translate(642.6 829.34) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.77,
    y: 416.09,
    width: 13.07,
    height: 10.53,
    transform: "translate(642.6 842.71) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.45,
    y: 314.21,
    width: 34.71,
    height: 8.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.18,
    y: 336.05,
    width: 10.31,
    height: 84.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 332.96,
    width: 11.49,
    height: 3.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.8,
    y: 322.61,
    width: 13.07,
    height: 10.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.59,
    y: 413.07,
    width: 11.49,
    height: 3.2,
    transform: "translate(830.67 829.34) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.8,
    y: 416.09,
    width: 13.07,
    height: 10.53,
    transform: "translate(830.67 842.71) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.54,
    y: 336.05,
    width: 10.31,
    height: 84.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.96,
    y: 332.96,
    width: 11.49,
    height: 3.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.16,
    y: 322.61,
    width: 13.07,
    height: 10.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.96,
    y: 413.07,
    width: 11.49,
    height: 3.2,
    transform: "translate(861.4 829.34) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.16,
    y: 416.09,
    width: 13.07,
    height: 10.53,
    transform: "translate(861.4 842.71) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.35,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.35,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.35,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.25,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.35,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.38,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.38,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.38,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.38,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.54,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.54,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.54,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.54,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.42,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.31,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.31,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.42,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.31,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.42,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.31,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.42,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.57,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.57,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.57,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.57,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.49,
    y: 331.92,
    width: 117.17,
    height: 75.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.51,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.41,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.41,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.51,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.41,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.51,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.41,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.51,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.67,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.67,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.67,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.67,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.54,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.44,
    y: 338.66,
    width: 8.05,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.44,
    y: 355.52,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.54,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.44,
    y: 370.91,
    width: 8.05,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.54,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.44,
    y: 386.31,
    width: 8.05,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.54,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.7,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.7,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.7,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.7,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.58,
    y: 370.91,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.48,
    y: 338.66,
    width: 8.04,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.48,
    y: 355.52,
    width: 8.04,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.58,
    y: 355.52,
    width: 9.9,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.48,
    y: 370.91,
    width: 8.04,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.58,
    y: 338.66,
    width: 9.9,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.48,
    y: 386.31,
    width: 8.04,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.58,
    y: 386.31,
    width: 9.9,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.74,
    y: 386.31,
    width: 9.69,
    height: 15.99,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.74,
    y: 370.91,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.74,
    y: 355.52,
    width: 9.69,
    height: 12.47,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.74,
    y: 338.66,
    width: 9.69,
    height: 13.93,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.65,
    y: 331.92,
    width: 117.17,
    height: 75.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-39"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 704.99,
    y1: 427.22,
    x2: 712.76,
    y2: 427.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.04,
    y1: 427.22,
    x2: 694.29,
    y2: 427.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.49,
    y1: 427.22,
    x2: 32.29,
    y2: 427.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629,346.32s-1.67,38.6-1.46,60.52,2.92,58.5,2.92,58.5l-1.87,3.55.2,5.22,12.11,3.55.83-4.38s2.09-1.67,2.09-2.72-.21-6.68-.21-8.35,6.89-79.3,6.89-79.3l2.92-.21,13.36,85.36L664,469.73l3.76,7.3,6.26-2.09,6.68.42a40,40,0,0,0,1.88-5.42c0-.84-2.3-1.88-2.3-3.34S678,377.41,678,377.41l-4-31.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.76,474.11l-6.88,5.43s-8.77,3.34-8.56,4.8,1.88,1.67,3.13,1.67h24.84l-.42-8.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.79,477s2.71,8.77,3.55,9.81,8.56,4.38,10.64,3.76,4.39-3.55,3.55-6.47-4.8-8.77-4.8-8.77l-6.68-.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.1,270.77l-10.44,1.46s-4.59,11.68-6.26,31.09-.21,43.62-.21,43.62h35.48s9.18-51.76,6.26-60.31a39.67,39.67,0,0,0-7.72-13.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.33,278.7s-4.8,15.86-4.8,29.63,2.09,63.86,2.09,63.86l-19.2-4L625,335.46l-2.09-35.06-16.07,16.91-12-6.82s26.61-36.18,27.45-36.38S646,269.5,646,269.5Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "621.76 288.46 622.92 300.4 618.75 287.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 621.25,
    y1: 283.29,
    x2: 621.5,
    y2: 285.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.53,270.06s23.62,6,24.46,6.16,26.47,47.14,26.47,47.14l-11.48,5-21.27-26.22-4.4,37.9,5.64,29-24.84,1.88L659,341.31l4.38-64.07Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "681.48 292.47 684.71 302.15 679.6 295.96",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.73,232.69s-3.88-2.77-3.51-4.07,8.87-6.28,10.16-6.83,16.81,2.77,19.4,4.43,5.35,11.46,5.72,16.07S665.42,256,665.42,256l-7.39.18.92-5.54-7.57-1.48,1.29-6.28-6.83-7.58,1.84-4.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.18,265.82,640.91,274s-3.21,8.45-2.48,8,4.66-4.23,4.66-4.23l9.4,5.71,10.87-5.42,5.39,5.83s1.17-16.47.3-17.78-5.54-2.34-6.71-2.48S647.18,265.82,647.18,265.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.94,228.62s-8.12,8.69-7.2,10.53a11.67,11.67,0,0,1,1.11,3.14s-6.47,5.73-5.54,6.84a17.3,17.3,0,0,0,3.51,2.59s-1.11,7.76,0,9.6,7.2.74,7.2.74,4.25,22.91,6.47,21.43,12.74-15.15,12.56-16.81.37-10.16.37-10.71-3.7-.19-3.7-.19,4.81-7,3-9.05-5.54-1.48-6.84-.56a9,9,0,0,0-2,2l-2-.56a39.73,39.73,0,0,0,1.66-4.25c.19-.92-4.25-5.35-4.06-6.09a3.78,3.78,0,0,1,.66-.92c1.47-1.71,4.88-5,4.88-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.48,243.87c-.08.91-.46,1.61-.84,1.58s-.62-.8-.53-1.71.46-1.61.84-1.57S644.57,243,644.48,243.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.36,239.46s2.34-1.7,3.93.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,253.37s4.46.31,6.69-2.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "646.02 262.06 652.77 261.12 647.14 267.59 646.02 262.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.57 340.75 612.4 336.14 607.22 332.57 607.57 340.75",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.87 323.59 613.68 327.99 610.79 338.1 605.89 334.11 609.87 323.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.43,304s-6,7.41-7,9.77,15.16,26.94,15.16,26.94l3.91-15.55-2.88-8.64,1.32-5-6.5-2.5",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.21,327.73l8.12-1.13s5.83,5.28,6.11,6a3.12,3.12,0,0,1-.14,2.22,3.84,3.84,0,0,1-1.11,1.67s-2.22,5.42-2.64,6.12-2.92.42-3.89.28-8.87-4.77-8.87-4.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "692.88 328.55 690.79 331.19 694.14 339.86 698.58 337.31 692.88 328.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.6,315.76l-13.11,12.65,8.89,11.26s17.84-14.6,16.87-17-5.15-8.2-5.15-8.2",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.79,331.19l-7.64-1.39s-5.84,5.28-6.12,6a3.12,3.12,0,0,0,.14,2.22,3.91,3.91,0,0,0,1.11,1.67s2.22,5.42,2.64,6.12,2.92.41,3.89.27,8.54-8.11,8.54-8.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostTolet);
export default __webpack_public_path__ + "static/media/postTolet.f948cf260f0fa6ad75125f290e7a2011.svg";
export { ForwardRef as ReactComponent };